module.exports = __webpack_public_path__ + "static/goswami-443b0f73de672d7e2d1a078d746697e3.jpg";